import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type PhotographersOwnInvoicesTabProps = {
    label: string;
};

const PhotographersOwnInvoicesRoute = '/photographer-invoice';

let routes = [PhotographersOwnInvoicesRoute];

function PhotographersOwnInvoicesTab({ label, ...props }: PhotographersOwnInvoicesTabProps) {
    function handleClick() {
        history.push(PhotographersOwnInvoicesRoute);
    }

    return (
        <BaseTab
            {...props}
            onClick={handleClick}
            label={label}
            route={PhotographersOwnInvoicesRoute}
        />
    );
}

function TranslatedPhotographersOwnInvoicesTab(props) {
    const label = Translate('header/nav/photographer-invoice');
    return <PhotographersOwnInvoicesTab {...props} label={label} />;
}

TranslatedPhotographersOwnInvoicesTab.routes = routes;

export default TranslatedPhotographersOwnInvoicesTab;
